import { AxiosConfig } from '../../componentes/axiosConfig';

export class EnviarComando {
    constructor() {
        this._axios                   = (new AxiosConfig()).instanciaAxios();
        this._formEnviarComando       = 'form[name=form-enviar-comando]';
        this._idModalTelaEnvioComando = 'modal-tela-envio-comando';
        this._idFormEnviarcomando     = 'form-enviar-comando';
        this._idDivConteudoModal      = 'conteudo-modal';
        this._inputComandoFormatado   = 'comandoFormatado';
    }

    executar() {
        const modalTelaEnvioComando = $(`#${this._idModalTelaEnvioComando}`);
        modalTelaEnvioComando.on('submit', this._formEnviarComando, (evento) => {
            evento.preventDefault();
            this._enviarComando();
        });
    }

    _enviarComando() {
        const dadosFormulario = new FormData(document.getElementById(this._idFormEnviarcomando));
        const urlEnvioComando = document.querySelector(this._formEnviarComando).action;

        this._axios.post(urlEnvioComando, dadosFormulario)
        .then(async (response) => {
            $(`#${this._idDivConteudoModal}`).html(
                $(response.data).find('#pagina-comando').html()
            );

            await this._copiarComandoSms(dadosFormulario);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    /**
     *
     * @param {FormData} dadosFormulario
     * @private
     */
    async _copiarComandoSms(dadosFormulario) {
        if (dadosFormulario.get('categoria') === 'sms') {
            const comando = document.getElementsByName(this._inputComandoFormatado);
            await navigator.clipboard.writeText(comando[0].value);
        }
    }
}
